module.exports = __webpack_public_path__ + "static/thumb2-7f3a396ae37cc057746d5d64ec45be57.jpg";